import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const HistorySection = lazy(() => import("./HistorySection"));
const JourneySection = lazy(() => import("./JourneySection"));
const AchievementSection = lazy(() => import("./AchievementSection"));

const OurStory = () => {
  return (
    <>
      <Helmet>
        <title>People of Lentera | Team Behind Innovative Tech Solutions</title>
        <meta
          name="description"
          content="Meet the talented team driving LENTERA’s success, from founders to technical and delivery experts, shaping our culture and products. With 6+ years of growth and long-term commitment, our people empower innovation, collaboration, and excellence."
        />
        <meta
          name="keywords"
          content="LENTERA founders, IT experts, B2B software specialists, company culture, skilled tech professionals, collaborative work environment, employee commitment, team-driven innovation, technology experts at Lentera."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <HistorySection />
        <JourneySection />
        <AchievementSection />
      </Suspense>
    </>
  );
};

export default OurStory;
